import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { baseURL, baseURLV1, imageURL } from "../../../service/API.js";
import Switch from "@material-ui/core/Switch";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useIntl } from "react-intl";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
  noLabel: {
    marginTop: theme.spacing.unit * 3,
  },
  inputColor: {
    backgroundColor: "#F4F6F9",
    borderRadius: "5px",
    borderWidth: "0",
  },
}));

export const CreatespecGroup = (props) => {
  const intl = useIntl();
  const suhbeader = useSubheader();
  const classes = useStyles();
  suhbeader.setTitle(intl.formatMessage({ id: "###", defaultMessage: "Create specGroup" }));
  const history = useHistory();
  const [group, setGroup] = useState();
  const [is_active, setIs_active] = useState('1');
  const [displayOrder, setDisplayOrder] = useState(0)

  const AlertError = (message) => {
    Swal.fire("Alert", message, "error");
  };


  useEffect(() => {

  }, []);

  const onSubmit = async (data) => {
    if (group === undefined || group === "") {
      return AlertError("Please insert group name !!");
    }

    if (is_active === undefined || is_active === "") {
      return AlertError("Please insert status !!");
    }


    var events = {
      groupname: group,
      is_active: is_active,
      ordering: String(displayOrder)


    };

    let apiUrls = `${baseURLV1}/specGroup`;
    let token = localStorage.getItem("Token");
    const resultAll = axios({
      method: "post",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: events,
    })
      .then(async (res) => {
        history.goBack();
      })
      .catch((err) => {
        Swal.fire(
          "Alert",
          "Your can not create spec group. !! " + err,
          "error"
        );
      });
  };


  return (
    <>
      <Card>
        <CardHeader title="Create specGroup"></CardHeader>
        <CardBody>
          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>
                *
              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "Spec Group" })}:{" "}
            </p>
            <input
              name="modelGroup"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={group}
              onChange={(e) => setGroup(e.target.value)}
            />
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>

            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>
                *
              </span>
              staus
            </p>
            <select name="cars" id="cars"
              value={is_active}
              onChange={(e) => {
                setIs_active(e.target.value)
              }}
            >
              <option value="1">true</option>
              <option value="0">false</option>
            </select>
          </div>

          <div className="form-inline" style={{ marginBottom: '25px' }}>
            <p style={{ marginTop: '15px', float: 'left', width: '20%' }}>
              <span style={{ color: "red" }}>
                *
              </span>
              display order
            </p>
            <input
              name="displayOrder"
              type="number"
              style={{
                height: '38px',
                width: '530px',
                backgroundColor: '#F4F6F9',
                borderRadius: '5px',
                borderWidth: '0'
              }}
              value={displayOrder}
              onChange={displayOrder => {
                if (displayOrder.target.value >= 0) {
                  setDisplayOrder(displayOrder.target.value)
                }
              }
              }
            />
          </div>

          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <div
              style={{
                marginTop: "15px",
                float: "left",
                width: "20%",
              }}
            ></div>
            <Link to="/specGroupManagement">
              <button type="button" className="btn btn-secondary wbt mr-5">
                {intl.formatMessage({ id: "###", defaultMessage: "Cancel" })}
              </button>
            </Link>
            <button className="btn btn-primary" onClick={() => onSubmit()}>
              {intl.formatMessage({ id: "###", defaultMessage: "Save" })}
            </button>
          </div>
        </CardBody>
      </Card>
    </>
  );
};
